export default __webpack_public_path__ + "/dist/images/login-img.db9d84ad4467d248b51703aeaf8f108d.png";